// extracted by mini-css-extract-plugin
module.exports = {"container":"BookmarkAction_container__XyGwY","icon":"BookmarkAction_icon__ubw8H","noActive":"BookmarkAction_noActive__kCkkj"};